<template>
  <div>
    <vb-login />
  </div>
</template>
<script>
import VbLogin from '@/@vb/components/Auth/Login'
export default {
  components: {
    VbLogin,
  },
}
</script>
